import store from "@/store";
import { UserType, UserTypes } from "@/types/abstract";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home/Home.vue";

Vue.use(VueRouter);

export const route_home = "/";
// export const route_bosyu = "/bosyu";
export const route_publicBosyu = "/public_bosyu";
export const route_castInfo = "/cast/";
export const route_castLogin = "/login_cast";
export const route_waiting = "/waiting";
export const route_guestLogin = "/login";
export const route_mypage = "/mypage";
export const route_updateInfo = "/mypage/updateInfo";
export const route_bankAccount = "/mypage/bank_account";
export const route_history = "/mypage/history";
export const route_privacyPolicy = "/privacy_policy";
export const route_terms = "/terms";
export const route_sitePolicy = "/site_policy";
export const route_search = "/search";
export const route_usage_history = "/usage_history/:historyId";

const routes: Array<RouteConfig> = [
  {
    path: route_home,
    name: "Home",
    component: Home,
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: false,
      isGuestAuth: true,
    },
  },
  // {
  //   path: route_bosyu,
  //   name: "Bosyu",
  //   component: () =>
  //     import(/* webpackChunkName: "bosyu" */ "../views/Bosyu/Bosyu.vue"),
  //   meta: {
  //     isShowHeader: false,
  //     isShowBottomNav: true,
  //     isCastAuth: true,
  //     isGuestAuth: false,
  //   },
  // },
  {
    path: route_castLogin,
    name: "CastLogin",
    component: () =>
      import(
        /* webpackChunkName: "cast_login" */ "../views/Login/LoginCast.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
      isCastAuth: false,
      isGuestAuth: false,
    },
  },
  {
    path: route_waiting,
    name: "Waiting",
    component: () =>
      import(/* webpackChunkName: "waiting" */ "../views/Home/Waiting.vue"),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
      isCastAuth: true,
      isGuestAuth: true,
    },
  },
  {
    path: route_guestLogin,
    name: "GuestLogin",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login/LoginGuest.vue"),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
    },
  },
  {
    path: route_castInfo + ":id",
    name: "CastInfo",
    component: () =>
      import(
        /* webpackChunkName: "castInfo" */ "../views/Home/cast/_userId.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: false,
      isGuestAuth: true,
    },
  },
  {
    path: route_mypage,
    name: "MyPage",
    component: () =>
      import(/* webpackChunkName: "mypage" */ "../views/MyPage/MyPage.vue"),
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: true,
      isGuestAuth: true,
    },
  },
  {
    path: route_updateInfo,
    name: "UpdateInfo",
    component: () =>
      import(
        /* webpackChunkName: "updateInfo" */ "../views/MyPage/UpdateInfo.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: true,
      isGuestAuth: true,
    },
  },
  {
    path: route_bankAccount,
    name: "BankAccount",
    component: () =>
      import(
        /* webpackChunkName: "bankAccount" */ "../views/MyPage/BankAccount.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: true,
      isGuestAuth: false,
    },
  },
  {
    path: route_history,
    name: "History",
    component: () =>
      import(/* webpackChunkName: "history" */ "../views/MyPage/History.vue"),
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: true,
      isGuestAuth: true,
    },
  },
  {
    path: route_privacyPolicy,
    name: "PrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "privacyPolicy" */ "../views/MyPage/PrivacyPolicy.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
      isCastAuth: false,
      isGuestAuth: false,
    },
  },
  {
    path: route_terms,
    name: "Terms",
    component: () =>
      import(/* webpackChunkName: "terms" */ "../views/MyPage/Terms.vue"),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
      isCastAuth: false,
      isGuestAuth: false,
    },
  },
  {
    path: route_sitePolicy,
    name: "SitePolicy",
    component: () =>
      import(
        /* webpackChunkName: "sitePolicy" */ "../views/MyPage/SitePolicy.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
      isCastAuth: false,
      isGuestAuth: false,
    },
  },
  {
    path: route_search,
    name: "Search",
    component: () =>
      import(/* webpackChunkName: "search" */ "../views/Play/Search.vue"),
    meta: {
      isShowHeader: false,
      isShowBottomNav: true,
      isCastAuth: false,
      isGuestAuth: true,
    },
  },
  {
    path: "/login_guest",
    name: "PreGuestLogin",
    redirect: (to) => {
      return route_guestLogin;
    },
  },
  {
    path: route_publicBosyu,
    name: "PublicBosyu",
    component: () =>
      import(
        /* webpackChunkName: "bosyu" */ "../views/Bosyu/PublicBosyuList.vue"
      ),
    meta: {
      isShowHeader: false,
      isShowBottomNav: false,
    },
  },
  // {
  //   path: route_usage_history,
  //   name: "UsageHistory",
  //   component: () =>
  //     import(/* webpackChunkName: "bosyu" */ "../views/publicHistory.vue"),
  //   meta: {
  //     isShowHeader: false,
  //     isShowBottomNav: false,
  //     isCastAuth: false,
  //     isGuestAuth: false,
  //   },
  // },
  {
    path: "*",
    name: "Other",
    redirect: (to) => {
      return route_guestLogin;
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  store.dispatch("finishLoading");
  await store.dispatch("auth/onAuth");
  // 認証状態
  const isAuth = store.getters["auth/isAuthenticated"];
  // ユーザータイプ
  const userType: UserType = store.getters["auth/getUserType"];

  const noAuthCheckPath = [route_publicBosyu, route_usage_history];

  if (to.path in noAuthCheckPath) {
    // authチェックなしで遷移
    next();
  }

  if (!to.meta?.isCastAuth && !to.meta?.isGuestAuth && isAuth) {
    if (to.path == route_castLogin || to.path == route_guestLogin) {
      // 未認証画面に遷移時にログイン状態の時
      if (userType == UserTypes.Guest) {
        next(route_home);
      } else {
        next(route_mypage);
      }
    }
    next();
    return;
  }
  if (to.meta?.isCastAuth | to.meta?.isGuestAuth && !isAuth) {
    if (userType == UserTypes.Cast) {
      next(route_castLogin);
      return;
    }
    // 認証が必要な画面に遷移時未ログインの場合はログイン画面にリダイレクト
    next(route_guestLogin);
    return;
  }

  if (isAuth && userType == UserTypes.Cast) {
    if (to.meta?.isCastAuth) {
      try {
        if (
          !(await store.dispatch("userData/isApproval")) &&
          to.path != route_waiting
        ) {
          // 未認証状態の時ウェイトページにリダイレクト
          next(route_waiting);
          return;
        }
        next();
        return;
      } catch (e) {
        console.log(e);
        await store.dispatch("auth/signOut");
        next(route_castLogin);
        return;
      }
    }

    next(route_mypage);
    return;
  }

  if (isAuth && userType == UserTypes.Guest) {
    if (to.meta?.isGuestAuth) {
      try {
        if (
          !(await store.dispatch("userData/isApproval")) &&
          to.path != route_waiting
        ) {
          // 未認証状態の時ウェイトページにリダイレクト
          next(route_waiting);
          return;
        }
        next();
        return;
      } catch (e) {
        console.log(e);
        await store.dispatch("auth/signOut");
        next(route_castLogin);
        return;
      }
    }
    next(route_home);
    return;
  }

  next();
});

export default router;
